import { create } from 'zustand'

import {
  BreadcrumbItemType,
  CategoryInterface,
  NomenclatureGroupInterface,
} from '@/types'

interface TreeTilesStateInterface {
  nomenclatureGroupsTree: NomenclatureGroupInterface[]
  breadcrumbItems: BreadcrumbItemType[]
  parentId: string
  categoriesTree: CategoryInterface[]
  categoriesPrioritiesVersion: number
  brandsPrioritiesVersion: number
  setBreadcrumbItems: (breadcrumbItems: BreadcrumbItemType[]) => void
  setParentId: (parentId: string) => void
  setCategoriesTree: (categoriesTree: CategoryInterface[]) => void
  setInitialTreeTilesStore: () => void
  setNomenclatureGroupsTree: (tree: NomenclatureGroupInterface[]) => void
  incrementCategoriesPrioritiesVersion: () => void
  incrementBrandsPrioritiesVersion: () => void
}

const initialState = {
  breadcrumbItems: [],
  parentId: '',
  categoriesTree: [],
  nomenclatureGroupsTree: [],
  categoriesPrioritiesVersion: 0,
  brandsPrioritiesVersion: 0,
}

export const useTreeTilesStore = create<TreeTilesStateInterface>((set) => ({
  ...initialState,
  setBreadcrumbItems: (breadcrumbItems: BreadcrumbItemType[]) =>
    set(() => ({ breadcrumbItems })),
  setParentId: (parentId: string) => set(() => ({ parentId })),
  setCategoriesTree: (categoriesTree: CategoryInterface[]) =>
    set(() => ({ categoriesTree })),
  setNomenclatureGroupsTree: (nomenclatureGroupsTree) =>
    set({ nomenclatureGroupsTree }),
  setInitialTreeTilesStore: () => set({ ...initialState }),
  incrementCategoriesPrioritiesVersion: () =>
    set((state) => ({
      categoriesPrioritiesVersion: state.categoriesPrioritiesVersion + 1,
    })),
  incrementBrandsPrioritiesVersion: () =>
    set((state) => ({
      brandsPrioritiesVersion: state.brandsPrioritiesVersion + 1,
    })),
}))
